import request from '@/utils/request'
import {
  InflowSourcePostRequest,
  InflowSourcePostResponse
} from '@/interface/api'

const prefix = 'api/v0/customer/medical-customers/inflow'

export const createInflowSource = (
  medicalBusinessId: string,
  inflowSource: InflowSourcePostRequest,
  clinicId?: string
): Promise<InflowSourcePostResponse | null> => {
  const url = clinicId
    ? `${prefix}/${medicalBusinessId}/${clinicId}/`
    : `${prefix}/${medicalBusinessId}/`
  return request({
    url,
    method: 'post',
    data: inflowSource
  })
    .then(
      (response) =>
        response.data.data.attributes as InflowSourcePostResponse
    )
    .catch(() => null)
}
